import { makeStyles } from '@mui/styles'
import { DefaultDialogStylesProps } from '../types/DefaultDialog'

export default ({
    zIndex,
    largePadding,
    minHeight,
    minWidth,
    width,
    height,
    scrollable = true,
}: DefaultDialogStylesProps) => {
    const useStyles = makeStyles((theme: any) => ({
        DefaultDialog: {
            zIndex: `${zIndex} !important`,
            '& .MuiDialog-container': {
                alignItems: 'center',
                paddingBottom: '0',
            },
        },

        DefaultDialogPaper: {
            zIndex: `${zIndex + 10} !important`,
            maxWidth: !width ? '90vw' : 'unset',
            minHeight,
            minWidth,
            width: width || '100%',
            height,
            maxHeight: '85%',
            overflowY: 'visible',
            display: 'flex',
            justifyContent: 'stretch',
            alignItems: 'stretch',
            borderRadius: '1.1rem !important',
            [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
                maxHeight: '80%',
            },
            [theme.breakpoints.up('lg')]: {
                maxWidth: !width ? '60vw' : 'unset',
            },
            [theme.breakpoints.up('xl')]: {
                maxWidth: !width ? '60vw' : 'unset',
            },
        },

        DefaultDialogPaperInnerQuitButton: {
            overflow: 'hidden',
        },

        DefaultDialogPaperTiny: {
            minHeight: '10vh',
            width: 'fit-content',
        },

        DefaultDialogPaperFullscreen: {
            minHeight: '100vh',
            minWidth: '100vw',
            borderRadius: '0 !important',
        },
        DefaultDialogCloserContainer: {
            zIndex: 9999,
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0,
            background: '#ffffff',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '.5rem',
            boxShadow: '0px 2px 22px rgba(255, 255, 255, 0.6)',
        },
        DefaultDialogCloser: {
            zIndex: `${zIndex + 10} important`,
            position: 'absolute',
            transform: 'translateY(calc(-100% - .7rem))',
            top: 0,
            right: 0,
            height: '3rem',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            background: 'transparent',
            borderRadius: '100px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: '#ffffff',
            border: '2px solid #ffffff',
            minWidth: 'unset',
        },

        DefaultDialogCloserinnerQuitButton: {
            position: 'static',
            transform: 'translateY(0)',
            color: theme.palette.typography.main,
            borderColor: theme.palette.typography.main,
        },

        DefaultDialogTitle: {
            padding: 0,
            fontWeight: 'bold',
            fontSize: '1.625em',
            marginBottom: '1rem',
            width: '100%',
        },

        DefaultDialogSubtitle: {
            padding: 0,
            fontSize: '1em',
            fontWeight: 'semibold',
        },

        DefaultDialogCloserText: {
            display: 'none',
            color: '#ffffff',
            fontWeight: '600',
            [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
                display: 'initial',
                marginRight: '1rem',
                lineHeight: 0,
            },
        },

        DefaultDialogCloserTextinnerQuitButton: {
            color: theme.palette.typography.main,
        },

        DefaultDialogCloserIcon: {
            '& *': {
                stroke: '#ffffff',
            },
        },

        DefaultDialogCloserIconinnerQuitButton: {
            '& *': {
                stroke: theme.palette.typography.main,
            },
        },

        DefaultDialogContent: {
            display: 'flex',
            flex: 1,
            justifyContent: 'stretch',
            alignItems: 'stretch',
            flexDirection: 'column',
            overflow: 'hidden',
            overflowY: 'hidden',
            padding: 0,
        },

        DefaultDialogContentWithFixedButtons: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
        },

        DefaultDialogFixedButtons: {
            width: '100%',
            background: '#ffffff',
            borderTop: `1px solid ${theme.palette.lightGrey.main}`,
            borderRadius: '0 0 8px 8px',
            padding: `1.5rem ${largePadding ? 1 : 1}rem !important`,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'stretch',
            gap: '1rem',
            [theme.breakpoints.up(theme.constants.formats.breakpoint)]: {
                padding: `1.5rem ${largePadding ? 6 : 2}rem !important`,
            },
            '& .MuiButton-root': {
                flex: 1,
            },
        },

        DefaultDialogButtons: {
            marginTop: '1rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'stretch',
            gap: '1rem',
            '& .MuiButton-root': {
                flex: 1,
            },
        },

        DefaultDialogContentDialog: {
            display: 'flex',
            justifyContent: 'stretch',
            alignItems: 'stretch',
            flexDirection: 'column',
            overflowY: scrollable ? 'auto' : 'hidden',
            padding: `${largePadding ? 3 : 3}rem !important`,
            width: '100%',
            [theme.breakpoints.up('md')]: {
                padding: `${largePadding ? 4 : 3}rem !important`,
            },
            [theme.breakpoints.up('lg')]: {
                padding: `${largePadding ? 6 : 3}rem !important`,
            },
            [theme.breakpoints.up('xl')]: {
                padding: `${largePadding ? 6 : 3}rem !important`,
            },
            '& .MuiDialogContent-root': {
                padding: 0,
            },
        },
    }))

    return useStyles()
}
